import { ApplicationRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BannerMessageService } from '../../services/banner-message.service';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import {
  BannerMessageDetails,
  BannerMessageLocation,
  BannerMessageSeverity,
  BannerMessageTargetApplication,
} from '../../models/banner-message-details.model';

@Component({
  selector: 'com-banner-message',
  templateUrl: './banner-message.component.html',
  styleUrls: ['./banner-message.component.scss'],
})
export class BannerMessageComponent implements OnInit, OnDestroy {
  @Input() location: BannerMessageLocation = BannerMessageLocation.all;
  @Input() application: BannerMessageTargetApplication = BannerMessageTargetApplication.any;
  @Input() width: string = '100%';
  @Input() bannerMessageDetails?: Array<BannerMessageDetails> = [];

  private _messages: Array<BannerMessageDetails> = [];
  private _destroy$ = new Subject<void>();

  public isVisible = new BehaviorSubject<boolean>(false);

  constructor(
    private bannerMessages: BannerMessageService,
    private appRef: ApplicationRef
  ) {}

  ngOnInit() {
    //NOTE isVisible - this.messages is different form this._messages as it is filtered to remove hidden and disabled items
    //This allows the close button to work by simply marking an item as hidden, rather than having to remove it from the array

    if (this.bannerMessageDetails && this.bannerMessageDetails.length > 0) {
      this._messages = this.bannerMessageDetails;
      this.isVisible.next(this.messages.length > 0);
    } else {
      this.bannerMessages
        .getMessages(this.location, this.application)
        .pipe(takeUntil(this._destroy$))
        .subscribe((data: Array<BannerMessageDetails>) => {
          this._messages = data;
          this.isVisible.next(this.messages.length > 0);
        });
    }
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  get messages(): Array<BannerMessageDetails> {
    return this._messages.filter((msg) => !msg.hidden && !msg.disabled);
  }

  set messages(messages: Array<BannerMessageDetails>) {
    this._messages = messages;
    this.appRef.tick();
  }

  getMsgClass(msg: BannerMessageDetails) {
    return BannerMessageSeverity[msg.severity];
  }

  getContainerStyle() {
    return `width:${this.width};margin:auto;`;
  }

  closeMessage(msg: BannerMessageDetails) {
    this.bannerMessages.hideMessage(msg);
    msg.hidden = true;
  }
}
